import { useCallback, useRef } from "react";
import type { PayloadAction } from "infrastructure/store";
import { useAppDispatch } from "./store";

const useResetState = (resetState: () => PayloadAction<undefined>) => {
    const dispatch = useAppDispatch();
    const helpers = {
        dispatch,
        resetState
    };
    const helpersRef = useRef(helpers);
    helpersRef.current = helpers;

    return useCallback(() => {
        const {
            dispatch,
            resetState
        } = helpersRef.current;

        dispatch(resetState());
    }, []);
};

export default useResetState;
